module.exports = __webpack_public_path__ + "static/img/ma3.a96dcf7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma3.gif
// module id = LMcn
// module chunks = 1